// ─── ProgressBar — upload progress indicator ─────────────────────────────────

import { useTranslation } from 'react-i18next';

interface ProgressBarProps {
  /** 0-100 */
  value: number;
  fileName?: string;
  ariaLabel?: string;
}

export function ProgressBar({ value, fileName, ariaLabel }: ProgressBarProps) {
  const { t } = useTranslation();
  const pct = Math.max(0, Math.min(100, value));

  return (
    <div
      style={{
        width: '100%',
        maxWidth: 480,
        display: 'flex',
        flexDirection: 'column',
        gap: 'var(--spacing-2)',
        marginTop: 'var(--spacing-3)',
      }}
    >
      {fileName && (
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            fontSize: 'var(--font-size-xs)',
            color: 'var(--color-text-secondary)',
            fontFamily: 'var(--font-family-mono)',
          }}
        >
          <span
            style={{
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
              maxWidth: '70%',
            }}
          >
            {fileName}
          </span>
          <strong style={{ color: 'var(--color-info)' }}>{pct}%</strong>
        </div>
      )}
      <div
        role="progressbar"
        aria-valuenow={pct}
        aria-valuemin={0}
        aria-valuemax={100}
        aria-label={ariaLabel ?? t('attachmentDemo.progress.ariaLabel', { pct })}
        style={{
          width: '100%',
          height: 8,
          background: 'var(--color-surface-elevated)',
          border: '1px solid var(--color-surface-border)',
          borderRadius: 'var(--radius-full)',
          overflow: 'hidden',
        }}
      >
        <div
          style={{
            height: '100%',
            width: `${pct}%`,
            background:
              'linear-gradient(90deg, var(--color-info), var(--color-brand-primary))',
            transition: 'width 0.2s linear',
          }}
        />
      </div>
    </div>
  );
}
